import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Notification  {
    _originalTypeClassName = "zSHR.BO.Notification";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Notification.translate = translateService;
}
this.Id = null;
this.DateCreated = null;
this.IsRead = false;
this.Text = null;
this.NotificationKey = null;
this._key = this.NotificationKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DateCreated:any;
IsRead:any;
Text:any;
PendingTask:any;
private _NotificationKey:any;
get NotificationKey(): any {
    return this._NotificationKey;
  }
set NotificationKey(value: any) {
    this._NotificationKey = value;
    this._key = value;
  }
static setPendingTask = ($this, value) => {
var oldValue = $this.PendingTask;
$this.PendingTask = value;
if (value != null) {
if (oldValue != null) {
Domain.PendingTask.removeNotifications(oldValue, $this);
}
Domain.PendingTask.addNotifications(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.NotificationKey == null || $this.NotificationKey == 0;
            }


}